<template>
	<div>
		<nav class="navbar navbar-expand-md navbar-dark blue-bg position-fixed">
		    <h1><a href="/" class="navbar-brand"><img style="width: 200px;" src="../assets/img/logo_white.png" draggable="false" class="img-fluid" alt="Style in Motion"></a></h1>
		    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbar7">
		        <span class="navbar-toggler-icon"></span>
		    </button>
		    <div class="navbar-collapse collapse justify-content-stretch" id="navbar7">
		        <ul class="navbar-nav ml-auto">
		            <li class="nav-item position-relative">
						<a class="nav-link" href="#services">{{ $t("navbar.business") }}</a>
					</li>
					<li class="nav-item position-relative">
						<a class="nav-link" href="#references">{{ $t("navbar.ref") }}</a>
					</li>
					<li class="nav-item position-relative">
						<a class="nav-link" href="#contact">{{ $t("navbar.contact") }}</a>
					</li>
					<li class="nav-item position-relative">
		        		<a class="nav-link" v-on:click="changeLocale">
		        			<p style="margin-bottom: 0;" v-if="lang == 'hu'"><b>hu</b> | en</p>
		        			<p style="margin-bottom: 0;" v-if="lang == 'en'">hu | <b>en</b></p>
		        		</a>
		      		</li>
		        </ul>
		    </div>
		</nav>
	</div>
</template>

<script>
	
	import { Bus } from "./../bus.js";

	export default {
		data() {
	        return {
	            lang: ''
	        };
	    },
		created(){
			this.lang = this.$i18n.locale;
		},
		metaInfo() {
		    return {
				meta: [
    			{
    				vmid: 'description',
			        name: 'description',
			        content: this.lang === 'hu' ? 'Branding, Film, Webfejlesztés, Social media' : 'Branding, Movie, Webdesign, Social media',
    			}
    		]
			};
		},
		methods: {
			changeLocale: function() {
				if(this.lang == "hu"){
	       			this.lang = "en";
	       		}else{
	       			this.lang = "hu";
	       		}
	       		this.$i18n.locale = this.lang;
	       		Bus.$emit("lang", this.lang);
			}
		}
	};
</script>


// WEBPACK FOOTER //
// src/components/Navbar.vue